export default 'CONFIG';
